import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import { TopBar } from './TopBar';
import { Navigation } from './Navigation';
import { Footer } from './Footer';
export function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="min-h-screen flex flex-col" data-id="element-63">
      <div className="sticky top-0 z-[100] w-full" data-id="element-64">
        <motion.div initial={false} animate={{
        height: isScrolled ? 0 : 'auto',
        opacity: isScrolled ? 0 : 1
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-65">
          <TopBar data-id="element-66" />
        </motion.div>
        <Navigation isScrolled={isScrolled} data-id="element-67" />
      </div>
      <div className="relative flex-grow" data-id="element-68">
        <AnimatePresence mode="wait" data-id="element-69">
          <motion.main key={location.pathname} initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -10
        }} transition={{
          duration: 0.4,
          ease: [0.22, 1, 0.36, 1]
        }} className="flex-grow" data-id="element-70">
            {children}
          </motion.main>
        </AnimatePresence>
      </div>
      <Footer data-id="element-71" />
    </div>;
}